import type { ProfileTabId } from './types'

/** Maps a profile tab id → legacy folder name (reference only; UI is native React). */
export const TAB_FOLDER: Record<ProfileTabId, string> = {
  'face-sheet': 'profile-face-sheet',
  admission: 'profile-admission',
  nursing: 'profile-nursing',
  social: 'profile-social',
  activity: 'profile-activity',
  dietary: 'profile-dietary',
  hp: 'profile-hp',
  immunization: 'profile-immunization',
  notes: 'profile-notes',
  'care-plans': 'profile-care-plans',
  assessments: 'profile-assessments',
  vitals: 'profile-vitals',
  mars: 'profile-mars',
  adls: 'profile-adls',
  hospitalization: 'profile-hospitalization',
  documents: 'profile-documents',
  incident: 'profile-incident',
  orders: 'profile-orders',
  log: 'profile-log',
  sdoh: 'profile-sdoh',
  'adv-adl': 'profile-adv-adl',
  'upload-pic': 'profile-upload-pic',
  schedule: 'profile-schedule',
  dashboard: 'dashboard',
  audit: 'audit-chart',
}

export const TAB_TITLE: Record<ProfileTabId, string> = {
  'face-sheet': 'Face Sheet',
  admission: 'Admission',
  nursing: 'Nursing',
  social: 'Social',
  activity: 'Activity',
  dietary: 'Dietary',
  hp: 'H&P',
  immunization: 'Immunization',
  notes: 'Notes',
  'care-plans': 'Care Plans',
  assessments: 'Assessments',
  vitals: 'Vitals',
  mars: 'MARS',
  adls: 'ADLS',
  hospitalization: 'Hospitalization',
  documents: 'Documents',
  incident: 'Incident',
  orders: 'Orders',
  log: 'Log',
  sdoh: 'SDOH',
  'adv-adl': 'ADV ADL',
  'upload-pic': 'Upload Pic',
  schedule: 'Schedule',
  dashboard: 'Dashboard',
  audit: 'Audit Chart',
}

export function isProfileTab(id: string): id is ProfileTabId {
  return id in TAB_FOLDER
}
